import { onboardingConverter, wwwConverter } from '@rategravity/marketing-components';

export const onboarding = onboardingConverter(process.env.GATSBY_ONBOARDING);
export const www = wwwConverter(process.env.GATSBY_WWW);
